import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b980954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "competitioninfo" }
const _hoisted_2 = { class: "display-2 textcenter" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Bemærk:")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Der vil blive taget billeder / film under stævnet, herunder fra vinder ceremonierne, der kan / vil blive brugt til marketing, sammen med vore samarbejdspartnere.")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Portrætbilleder vil dog kunne fravælges på stedet.")
const _hoisted_9 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Please Note:")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Pictures / films will be taken during the tournament, not least during the Price Ceremony, that can / will be used as marketing with our business partners.")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Portrait images however, can be opt-out on the spot.")
const _hoisted_16 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "competitionarea"
}
const _hoisted_19 = { class: "competitioncontainer row" }
const _hoisted_20 = {
  key: 0,
  class: "flex md7 xs12"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center mb-2" }, "Sprog / Language", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Dansk")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_24 = {
  key: 0,
  class: "size mb-2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Der er mulighed for tilmelding i følgende rækker:", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "size mb-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Register for the categories below:", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 2,
  style: {"display":"flex","justify-content":"center","align-items":"center","margin-block":"12px"}
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Registration For DC Events")
const _hoisted_32 = { class: "rowinfo row justify--center align--baseline" }
const _hoisted_33 = { class: "flex md3 xs6 center" }
const _hoisted_34 = {
  key: 0,
  class: "flex md3 xs6 center"
}
const _hoisted_35 = {
  key: 1,
  class: "flex md7 xs12"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center mb-2" }, "Sprog / Language", -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Dansk")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("English")
const _hoisted_39 = { class: "size mb-2" }
const _hoisted_40 = { class: "rowinfo row justify--center align--baseline" }
const _hoisted_41 = { class: "flex md3" }
const _hoisted_42 = { class: "flex md4 xs12" }
const _hoisted_43 = {
  key: 0,
  class: "timeandplace mb-4"
}
const _hoisted_44 = { class: "textcenter size" }
const _hoisted_45 = ["href"]
const _hoisted_46 = { class: "textcenter size" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "textcenter size" }
const _hoisted_49 = ["href"]
const _hoisted_50 = {
  key: 1,
  class: "timeandplace mb-4"
}
const _hoisted_51 = { class: "textcenter size" }
const _hoisted_52 = ["href"]
const _hoisted_53 = { class: "timeandplace mb-4" }
const _hoisted_54 = { class: "display-4 textcenter mb-2" }
const _hoisted_55 = { class: "size" }
const _hoisted_56 = { class: "capitalize" }
const _hoisted_57 = { class: "size" }
const _hoisted_58 = { class: "size" }
const _hoisted_59 = { class: "capitalize" }
const _hoisted_60 = { class: "size" }
const _hoisted_61 = { class: "capitalize" }
const _hoisted_62 = { class: "size" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode()
const _hoisted_64 = ["href"]
const _hoisted_65 = {
  key: 2,
  class: "contact"
}
const _hoisted_66 = { class: "display-4 textcenter mb-2" }
const _hoisted_67 = { class: "size" }
const _hoisted_68 = { class: "size" }
const _hoisted_69 = ["href"]
const _hoisted_70 = { class: "size" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email: ", -1))
const _hoisted_72 = ["href"]
const _hoisted_73 = {
  key: 0,
  class: "size"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Stævneleder: ", -1))
const _hoisted_75 = { href: '/staevne/staevneledere/' }
const _hoisted_76 = {
  key: 1,
  class: "size"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Overdommer: ", -1))
const _hoisted_78 = { href: '/staevne/overdommere/' }
const _hoisted_79 = { class: "display-6 textcenter mb-2" }
const _hoisted_80 = {
  class: "flex",
  style: {"display":"flex","margin":"auto","max-width":"50%"}
}
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_82 = {
  key: 0,
  class: "va-table-responsive row"
}
const _hoisted_83 = { class: "flex md12 va-table va-table--clickable va-table--hoverable" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", null, "Licens"),
    /*#__PURE__*/_createElementVNode("th", null, "Event"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_85 = /*#__PURE__*/_createTextVNode("Check-In")
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_87 = { class: "display-6 textcenter mb-2" }
const _hoisted_88 = {
  key: 0,
  class: "textcenter size"
}
const _hoisted_89 = {
  key: 1,
  class: "va-table-responsive row"
}
const _hoisted_90 = { class: "flex md12 va-table va-table--clickable va-table--hoverable" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "sorting" }, "Navn"),
    /*#__PURE__*/_createElementVNode("th", { class: "sorting" }, "Klub")
  ])
], -1))
const _hoisted_92 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_93 = { class: "disply-6 textcenter mb-2" }
const _hoisted_94 = {
  key: 0,
  class: "textcenter size"
}
const _hoisted_95 = {
  key: 1,
  class: "va-table-responsive row"
}
const _hoisted_96 = { class: "flex md12 va-table va-table--clickable va-table--hoverable" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Nr:"),
    /*#__PURE__*/_createElementVNode("th", { class: "textecenter" }, "Ranglistepoint"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Licens")
  ])
], -1))
const _hoisted_98 = { class: "textcenter" }
const _hoisted_99 = { class: "textcenter" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { key: 1 }
const _hoisted_102 = {
  key: 2,
  class: "textcenter"
}
const _hoisted_103 = {
  key: 3,
  class: "textcenter"
}
const _hoisted_104 = {
  key: 2,
  class: "row justify--center"
}
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_106 = {
  key: 0,
  class: "display-6 textcenter"
}
const _hoisted_107 = {
  key: 1,
  class: "display-6 textcenter"
}
const _hoisted_108 = {
  class: "layout gutter--xl",
  style: {"min-height":"350px"}
}
const _hoisted_109 = { class: "row justify--center" }
const _hoisted_110 = { class: "flex" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = /*#__PURE__*/_createTextVNode("Ikke medlem? ")
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Bliv medlem her")
const _hoisted_114 = { key: 1 }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("First time playing in Denmark? ")
const _hoisted_116 = /*#__PURE__*/_createTextVNode("Register here")
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "All have to register if they haven´t played an event before in 2023, when you have been registered, you can easy search you from the list of foreign players", -1))
const _hoisted_119 = {
  key: 0,
  class: "row justify--center"
}
const _hoisted_120 = { class: "flex" }
const _hoisted_121 = { class: "row justify--center" }
const _hoisted_122 = { class: "md4 flex selectInputDiv" }
const _hoisted_123 = {
  key: 0,
  class: "md4 flex selectInputDiv"
}
const _hoisted_124 = { class: "row justify--center" }
const _hoisted_125 = {
  key: 0,
  class: "md4 flex selectInputDiv"
}
const _hoisted_126 = {
  key: 1,
  class: "md4 flex selectInputDiv"
}
const _hoisted_127 = { key: 1 }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Ved en hold tilmelding til Herrehold bliver spillerne også automatisk tilmeldt to herredoubler og fire herresingler.")
], -1))
const _hoisted_129 = { class: "row justify--center" }
const _hoisted_130 = { class: "flex md6" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hold 1:", -1))
const _hoisted_132 = { class: "flex md6" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hold 2:", -1))
const _hoisted_134 = { key: 2 }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("i", null, "Ved tilmedling til damepairs, vil deltagerne også automatisk blive tilmeldt til to damesingler.")
], -1))
const _hoisted_136 = [
  _hoisted_135
]
const _hoisted_137 = { class: "textcenter size" }
const _hoisted_138 = /*#__PURE__*/_createTextVNode("Ok")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_collapse = _resolveComponent("va-collapse")!
  const _component_va_accordion = _resolveComponent("va-accordion")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, "Info om " + _toDisplayString(_ctx.competitionData.competitionName), 1),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("p", null, _hoisted_9, 512), [
        [_vShow, _ctx.languageValue === 1]
      ]),
      _withDirectives(_createElementVNode("p", null, _hoisted_16, 512), [
        [_vShow, _ctx.languageValue === 2]
      ])
    ]),
    (_ctx.error || _ctx.competitionData.competitionStatus !== true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString('Fejl: ' + _ctx.error), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_ctx.competitionData.competitionStart > _ctx.toDaysDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_va_button_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_button, {
                        size: "small",
                        color: (_ctx.languageValue === 1 ? '#ab0033' : 'primary'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.languageValue = 1))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_va_button, {
                        size: "small",
                        color: (_ctx.languageValue === 2 ? '#ab0033' : 'primary'),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.languageValue = 2))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  }),
                  (_ctx.languageValue === 1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_24, _hoisted_26))
                    : (_openBlock(), _createElementBlock("p", _hoisted_27, _hoisted_29)),
                  (_ctx.tempCompetition?.staevner_registration_status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_va_button, {
                          size: "medium",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dcEventRegistrationModal = true))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_va_accordion, { multiply: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitionData.competitionRows, (competitionRow, index) => {
                        return (_openBlock(), _createBlock(_component_va_collapse, {
                          key: index,
                          header: competitionRow.staevne_raekker_navn + ', ' + _ctx.findPrice(competitionRow.staevne_raekker_navn) + ' kr.'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_inner_loading, {
                              loading: !_ctx.playerDataRetrievedAndReady,
                              size: 40,
                              color: '#7f1f7f'
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_va_button, {
                                      onClick: ($event: any) => (_ctx.viewSignUps(competitionRow.id, competitionRow.staevne_raekker_navn)),
                                      disabled: !_ctx.playerDataRetrievedAndReady
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Vis tilmeldte' : 'Show players'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick", "disabled"])
                                  ]),
                                  (_ctx.competitionData.competitionLastEntryDate >= _ctx.toDaysDate)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _createVNode(_component_va_button, {
                                          onClick: ($event: any) => (_ctx.playerRegistration(competitionRow.id, competitionRow.staevne_raekker_navn)),
                                          disabled: !_ctx.playerDataRetrievedAndReady
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Tilmelding' : 'Register'), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "disabled"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["loading"])
                          ]),
                          _: 2
                        }, 1032, ["header"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_va_button_group, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_button, {
                        size: "small",
                        color: (_ctx.languageValue === 1 ? '#ab0033' : 'primary'),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.languageValue = 1))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_va_button, {
                        size: "small",
                        color: (_ctx.languageValue === 2 ? '#ab0033' : 'primary'),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.languageValue = 2))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 1
                      }, 8, ["color"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", _hoisted_39, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Se stævneresultater:' : 'See Event Results'), 1)
                  ]),
                  _createVNode(_component_va_accordion, { multiply: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitionData.competitionRows, (competitionRow, index) => {
                        return (_openBlock(), _createBlock(_component_va_collapse, {
                          key: index,
                          header: competitionRow.staevne_raekker_navn
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_va_button, {
                                  onClick: ($event: any) => (_ctx.viewResults(competitionRow.id, competitionRow.staevne_raekker_navn))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Se resultater' : 'See results'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["header"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])),
            _createElementVNode("div", _hoisted_42, [
              (_ctx.competitionData.competitionInvitation.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("p", _hoisted_44, [
                      _createElementVNode("strong", null, [
                        (_ctx.competitionData.competitionInvitation[0] !== undefined)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.APIURL + _ctx.competitionData.competitionInvitation[0].url,
                              target: "_blank"
                            }, _toDisplayString(_ctx.competitionData.competitionInvitation[0].name), 9, _hoisted_45))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_46, [
                      _createElementVNode("strong", null, [
                        (_ctx.competitionData.competitionInvitation[1] !== undefined)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.APIURL + _ctx.competitionData.competitionInvitation[1].url,
                              target: "_blank"
                            }, _toDisplayString(_ctx.competitionData.competitionInvitation[1].name), 9, _hoisted_47))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_48, [
                      _createElementVNode("strong", null, [
                        (_ctx.competitionData.competitionInvitation[2] !== undefined)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.APIURL + _ctx.competitionData.competitionInvitation[2].url,
                              target: "_blank"
                            }, _toDisplayString(_ctx.competitionData.competitionInvitation[2].name), 9, _hoisted_49))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.competitionData.competitionStaevneLink !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("p", _hoisted_51, [
                      _createElementVNode("a", {
                        href: _ctx.competitionData.competitionStaevneLink,
                        target: "_blank"
                      }, "Følg på DartConnect", 8, _hoisted_52)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("h4", _hoisted_54, _toDisplayString(_ctx.languageValue === 1 ? 'Tid og sted' : 'Time and Location'), 1),
                _createElementVNode("p", _hoisted_55, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Start: ' : 'Start: '), 1),
                  _createElementVNode("span", _hoisted_56, _toDisplayString((_ctx.competitionData.competitionStart !== null && _ctx.competitionData.competitionStart.length >= 1 ? _ctx.danishDataWClockArr(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.competitionData.competitionStart))[0] : '-')), 1)
                ]),
                _createElementVNode("p", _hoisted_57, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Klokken: ' : 'Time: '), 1),
                  _createTextVNode(" " + _toDisplayString((_ctx.competitionData.competitionStart !== null && _ctx.competitionData.competitionStart.length >= 1 ? _ctx.danishDataWClockArr(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.competitionData.competitionStart))[1] : '-')), 1)
                ]),
                _createElementVNode("p", _hoisted_58, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Slut: ' : 'Finish: '), 1),
                  _createElementVNode("span", _hoisted_59, _toDisplayString((_ctx.competitionData.competitionEnd !== null && _ctx.competitionData.competitionEnd.length >= 1 ?(new Date(_ctx.competitionData.competitionEnd)).toLocaleDateString('da-DK', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'}).replaceAll('den', 'd.') : '-')), 1)
                ]),
                _createElementVNode("p", _hoisted_60, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Sidste tilmelding: ' : 'Latest Registration: '), 1),
                  _createElementVNode("span", _hoisted_61, _toDisplayString((_ctx.competitionData.competitionLastEntryDate !== null && _ctx.competitionData.competitionLastEntryDate.length >= 1 ? (new Date(_ctx.competitionData.competitionLastEntryDate)).toLocaleDateString('da-DK', {weekday: 'long'}) + ' d. ' + (new Date(_ctx.competitionData.competitionLastEntryDate)).toLocaleDateString('da-DK', {day: 'numeric', month: 'numeric', year: '2-digit'}).replaceAll('.', '/') : '-')), 1)
                ]),
                _createElementVNode("p", _hoisted_62, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Sted: ' : 'Location: '), 1),
                  _hoisted_63,
                  _createElementVNode("a", {
                    href: 'http://maps.apple.com/?q=' + (_ctx.convertHTMLToText(_ctx.competitionData.competitionPlace).toLowerCase().replace(/[^a-z0-9 - æ ø å]/g, '+')),
                    target: "_blank"
                  }, _toDisplayString(_ctx.convertHTMLToText(_ctx.competitionData.competitionPlace)), 9, _hoisted_64)
                ]),
                _createVNode(_component_va_divider)
              ]),
              (_ctx.competitionData.clubName !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("h4", _hoisted_66, _toDisplayString(_ctx.languageValue === 1 ? 'Kontaktinfo' : 'Contact Information'), 1),
                    _createElementVNode("p", _hoisted_67, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Arrangør: ' : 'Organizer: '), 1),
                      _createVNode(_component_router_link, {
                        to: {name: 'theClub', params: { slug: _ctx.competitionData.clubSlug }, }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString((_ctx.competitionData.clubName === 'Gæsteklubben' ? 'Dansk Dart Union' : _ctx.competitionData.clubName)), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("p", _hoisted_68, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.languageValue === 1 ? 'Telefon: ' : 'Phone: '), 1),
                      _createElementVNode("a", {
                        href: 'tel:' + _ctx.competitionData.clubTelephone
                      }, _toDisplayString(_ctx.competitionData.clubTelephone), 9, _hoisted_69)
                    ]),
                    _createElementVNode("p", _hoisted_70, [
                      _hoisted_71,
                      _createElementVNode("a", {
                        href: 'mailto:' + _ctx.competitionData.clubEmail
                      }, _toDisplayString(_ctx.competitionData.clubEmail), 9, _hoisted_72)
                    ]),
                    (_ctx.competitionData.competitionStaevneleder !== null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("a", _hoisted_75, _toDisplayString(_ctx.competitionData.competitionStaevneleder), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.competitionData.competitionOverdommer !== null)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("a", _hoisted_78, _toDisplayString(_ctx.competitionData.competitionOverdommer), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.dcEventRegistrationModal,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dcEventRegistrationModal) = $event)),
      size: "large",
      "hide-default-actions": "",
      "overlay-opacity": "0.5"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          class: "btn",
          color: "secondary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dcEventRegistrationModal = false, _ctx.filteredTournametRegisteredPlayers = [], _ctx.playearSearchInputValue = null)))
        }, {
          default: _withCtx(() => [
            _hoisted_86
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("h6", _hoisted_79, _toDisplayString(_ctx.competitionData.competitionName), 1),
        _createElementVNode("div", _hoisted_80, [
          _createVNode(_component_va_input, {
            modelValue: _ctx.playearSearchInputValue,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.playearSearchInputValue) = $event)),
            label: "Søg",
            onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.findDCCompetitionPlayer()), ["enter"]))
          }, {
            prependInner: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "person_search" })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_va_button, {
            size: "small",
            class: "btn ml-2",
            rounded: false,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.findDCCompetitionPlayer()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_va_icon, { name: "search" }),
              _hoisted_81
            ]),
            _: 1
          })
        ]),
        (_ctx.filteredTournametRegisteredPlayers.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
              _createElementVNode("table", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTournametRegisteredPlayers, (player) => {
                    return (_openBlock(), _createElementBlock("tr", { key: player }, [
                      _createElementVNode("td", null, _toDisplayString(player?.firstName) + _toDisplayString(player?.lastName), 1),
                      _createElementVNode("td", null, _toDisplayString(player?.licens), 1),
                      _createElementVNode("td", null, _toDisplayString(player?.staevne_raekker_id.staevne_raekker_navn), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_va_button, {
                          color: "success",
                          onClick: ($event: any) => (_ctx.registerPlayerToDCEvent(player)),
                          disabled: _ctx.isEventRegistrationDissable(player)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_85
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.rowRegistrationDisplayModal,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rowRegistrationDisplayModal) = $event)),
      size: "large",
      "hide-default-actions": "",
      "overlay-opacity": "0.5"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          class: "btn",
          onClick: _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rowRegistrationDisplayModal = false)))
        }, {
          default: _withCtx(() => [
            _hoisted_92
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("h6", _hoisted_87, "Tilmeldte til " + _toDisplayString(_ctx.competitionData.competitionName) + ", række " + _toDisplayString(_ctx.rowName), 1),
        (_ctx.filteredSignUps(_ctx.rowId).length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_88, "Ingen tilmeldt endnu"))
          : (_openBlock(), _createElementBlock("div", _hoisted_89, [
              _createElementVNode("table", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSignUps(_ctx.rowId), (signUp) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: signUp.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.getNamesFromObject(signUp.medlem_id, signUp.usp_id)), 1),
                      _createElementVNode("td", null, _toDisplayString((!_ctx.rowName.toLowerCase().includes('hold') ? _ctx.getClubOrCountryFromObject(signUp.medlem_id, signUp.usp_id) : _ctx.singleClubOrCountryFromObject(signUp.medlem_id))), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.resultsModal,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.resultsModal) = $event)),
      size: "large",
      "hide-default-actions": "",
      "overlay-opacity": "0.5"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          class: "btn",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resultsModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_105
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("h6", _hoisted_93, "Resultater for " + _toDisplayString(_ctx.competitionData.competitionName) + ", række " + _toDisplayString(_ctx.rowName), 1),
        (_ctx.competitionResults.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_94, "Ingen resultater endnu"))
          : (_openBlock(), _createElementBlock("div", _hoisted_95, [
              _createElementVNode("table", _hoisted_96, [
                _hoisted_97,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.competitionResults, (competitionResult) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: competitionResult.id
                    }, [
                      _createElementVNode("td", _hoisted_98, _toDisplayString(competitionResult.staevne_resultater_placering), 1),
                      _createElementVNode("td", _hoisted_99, _toDisplayString((competitionResult.staevne_ranglistepoint === undefined ? '' : competitionResult.staevne_ranglistepoint)), 1),
                      (competitionResult.medlem_id.medlem_licens !== 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_100, [
                            _createVNode(_component_router_link, {
                              to: {name: 'Memberinfo', params: { slug: competitionResult.medlem_id.id.toString() + '-' + _ctx.convertToSlug(competitionResult.staevne_resultater_navn) }, }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(competitionResult.staevne_resultater_navn), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_101, _toDisplayString(competitionResult.staevne_resultater_navn), 1)),
                      (competitionResult.medlem_id.medlem_licens === 0)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_102, "Udenlandsk spiller"))
                        : (_openBlock(), _createElementBlock("td", _hoisted_103, _toDisplayString(competitionResult.medlem_id.medlem_licens), 1))
                    ]))
                  }), 128))
                ])
              ])
            ])),
        ((_ctx.allResults !== true && _ctx.resultsArraySize > 16))
          ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
              _createElementVNode("p", {
                class: "flex sorting",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.viewAll()))
              }, "Se alle resultater...")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.playerRegistrationModal,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.playerRegistrationModal) = $event)),
      size: "large",
      "overlay-opacity": "0.5",
      "fixed-layout": true,
      "hide-default-actions": "",
      "no-dismiss": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          color: "success",
          class: "mr-2",
          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.registerSelectedPlayer()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Læg tilmelding i kurven' : 'Add to cart'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_va_button, {
          color: "secondary",
          class: "ml-2",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.playerRegistrationModal = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Annuller' : 'Cancel'), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_ctx.languageValue === 1)
          ? (_openBlock(), _createElementBlock("h6", _hoisted_106, "Tilmelding til " + _toDisplayString(_ctx.seriesName), 1))
          : (_openBlock(), _createElementBlock("h6", _hoisted_107, "Registration for " + _toDisplayString(_ctx.seriesName), 1)),
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _createElementVNode("div", _hoisted_110, [
              (_ctx.languageValue === 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_111, [
                    _createElementVNode("i", null, [
                      _hoisted_112,
                      _createVNode(_component_router_link, { to: "/medlemmer/nyt-medlem/" }, {
                        default: _withCtx(() => [
                          _hoisted_113
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_114, [
                    _createElementVNode("i", null, [
                      _hoisted_115,
                      _createVNode(_component_router_link, { to: "/medlemmer/nyt-medlem/" }, {
                        default: _withCtx(() => [
                          _hoisted_116
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_117,
                    _hoisted_118
                  ]))
            ])
          ]),
          ((_ctx.competitionData.competitionCategory === 'kategori1' || _ctx.competitionData.competitionCategory === 'kategori4') && (!_ctx.seriesName.endsWith('B') && !_ctx.seriesName.startsWith('C')))
            ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                _createElementVNode("div", _hoisted_120, [
                  _createVNode(_component_va_button, {
                    class: "mr-2",
                    color: (_ctx.danishOrForeignPlayerValue === 1 ? 'success' : 'primary'),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.danishOrForeignPlayer(1)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Dansk spiller' : 'Danish player'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"]),
                  _createVNode(_component_va_button, {
                    class: "ml-2",
                    color: (_ctx.danishOrForeignPlayerValue === 2 ? 'success' : 'primary'),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.danishOrForeignPlayer(2)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Udenlandsk spiller' : 'Foreign player'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_121, [
            _createElementVNode("div", _hoisted_122, [
              _createVNode(_component_va_select, {
                class: "selectInput",
                modelValue: _ctx.player1Value,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.player1Value) = $event)),
                options: _ctx.playerOptions,
                searchable: "",
                bordered: "",
                label: "Vælg spiller",
                "text-by": (playerOptions) => playerOptions.displayText,
                "track-by": (playerOptions) => playerOptions.id
              }, null, 8, ["modelValue", "options", "text-by", "track-by"])
            ]),
            ((_ctx.seriesName.toLowerCase().includes('pairs') || _ctx.seriesName.toLowerCase().includes('double') || _ctx.seriesName.toLowerCase().includes('hold')))
              ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                  _createVNode(_component_va_select, {
                    class: "selectInput",
                    modelValue: _ctx.player2Value,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.player2Value) = $event)),
                    options: _ctx.playerOptions,
                    searchable: "",
                    bordered: "",
                    label: "Vælg spiller 2",
                    "text-by": (playerOptions) => playerOptions.displayText,
                    "track-by": (playerOptions) => playerOptions.id
                  }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_124, [
            ((_ctx.seriesName.toLowerCase().includes('hold')))
              ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                  _createVNode(_component_va_select, {
                    class: "selectInput",
                    modelValue: _ctx.player3Value,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.player3Value) = $event)),
                    options: _ctx.playerOptions,
                    searchable: "",
                    bordered: "",
                    label: "Vælg spiller 3",
                    "text-by": (playerOptions) => playerOptions.displayText,
                    "track-by": (playerOptions) => playerOptions.id
                  }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.seriesName.toLowerCase().includes('hold')))
              ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                  _createVNode(_component_va_select, {
                    class: "selectInput",
                    modelValue: _ctx.player4Value,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.player4Value) = $event)),
                    options: _ctx.playerOptions,
                    searchable: "",
                    bordered: "",
                    label: "Vælg spiller 4",
                    "text-by": (playerOptions) => playerOptions.displayText,
                    "track-by": (playerOptions) => playerOptions.id
                  }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.competitionData.competitionCategory === 'kategori2' && _ctx.seriesName.toLowerCase().includes('hold'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                _hoisted_128,
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    _hoisted_131,
                    _createElementVNode("p", null, _toDisplayString((_ctx.player1Value.displayText !== undefined && _ctx.player3Value.displayText !== undefined ? _ctx.player1Value.displayText + ' & ' + _ctx.player3Value.displayText : '')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _hoisted_133,
                    _createElementVNode("p", null, _toDisplayString((_ctx.player2Value.displayText !== undefined && _ctx.player4Value.displayText !== undefined ? _ctx.player2Value.displayText + ' & ' + _ctx.player4Value.displayText : '')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.competitionData.competitionCategory === 'kategori2' && _ctx.seriesName.toLowerCase().includes('damepairs'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_134, _hoisted_136))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.feedBackModal,
      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.feedBackModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.5"
    }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_137, _toDisplayString(_ctx.feedBackMessage), 1)
      ]),
      _: 2
    }, [
      (_ctx.successRegistration)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createVNode(_component_va_button, {
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.feedBackModal = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_138
                ]),
                _: 1
              })
            ])
          }
        : {
            name: "footer",
            fn: _withCtx(() => [
              _createVNode(_component_va_button, {
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.feedBackModal = false)),
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Tilmeld flere' : 'Register more'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_va_button, {
                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$router.push('/kurven'))),
                class: "ml-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.languageValue === 1 ? 'Til kassen' : 'Go to checkout'), 1)
                ]),
                _: 1
              })
            ])
          }
    ]), 1032, ["modelValue"])
  ]))
}